var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { EntityValidationsService } from "../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../client-validation-system/validations.models";
import { RequestClient } from "../../../services/basics/request-client.service";
import { I18N } from 'aurelia-i18n';
import { Router } from "aurelia-router";
var ForgotPassword = /** @class */ (function () {
    function ForgotPassword(requestClient, entityValidationsService, notificationService, i18N, router) {
        this.requestClient = requestClient;
        this.entityValidationsService = entityValidationsService;
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.router = router;
        this.sent = false;
    }
    ForgotPassword.prototype.attached = function () {
        var rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "ForgotPassword",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                    errorMessage: this.i18N.tr('email-required-text'),
                    parameters: null, property: "email",
                    validationType: ValidationTypeEnum.Required
                }, {
                    errorMessage: this.i18N.tr('email-invalid-text'),
                    parameters: null, property: "email",
                    validationType: ValidationTypeEnum.Email
                }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    };
    ForgotPassword.prototype.signin = function () {
        this.router.navigate("/");
    };
    ForgotPassword.prototype.submit = function () {
        var _this = this;
        this.submitting = true;
        return new Promise(function (resolve, reject) {
            _this.validator.validate().then(function (validationResponse) {
                if (validationResponse.valid) {
                    var promise = _this.requestClient.post("User/ForgotPassword", { email: _this.email });
                    promise.then(function (response) {
                        if (response && response.isSuccess) {
                            _this.submitting = false;
                            _this.notificationService.show(_this.i18N.tr('email-sent-successfully-text'), _this.i18N.tr('email-sent-to-text') + " " + _this.email, NotificationType.Success, 3000);
                            _this.sent = true;
                        }
                        else {
                            _this.submitting = false;
                            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('failed-to-send-email-text'), NotificationType.Error, 3000);
                        }
                        resolve();
                    }).catch(function (ex) {
                        _this.submitting = false;
                        _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('failed-to-send-email-text'), NotificationType.Error, 3000);
                        resolve();
                    });
                }
                else {
                    _this.submitting = false;
                    resolve();
                }
            }).catch(function (ex) {
                _this.submitting = true;
                resolve();
            });
        });
    };
    ForgotPassword = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [RequestClient, EntityValidationsService,
            NotificationClientService, I18N, Router])
    ], ForgotPassword);
    return ForgotPassword;
}());
export { ForgotPassword };
